import {UsageDataDto} from '../dto/usage-data.dto';
import {ExcelUsageDto} from '../dto/usage-excel.dto';
import {makeUsageList} from './make-usage-list';
import 'reflect-metadata';
import {IUsageDateType} from 'interfaces/interface';

/**
 * 사용량 엑셀 데이터 생성
 * @param param - 사용량 엑셀 시트를 작성하는데 필요한 데이터
 * @param locale - 지역
 * @param dateType - 날짜 타입
 * @returns 사용량 엑셀 DTO
 * @public
 */
export function createUsageExcelData(
  param: UsageDataDto,
  locale: validator.MobilePhoneLocale,
  dateType: IUsageDateType,
): ExcelUsageDto {
  const usageData = new ExcelUsageDto();

  // 사용자수 리스트
  usageData.usageList = makeUsageList(1, param.usageList, dateType);

  return usageData;
}
